
export function initDeviceDetection(): void {
  const isMobile = {
    Android: (): boolean => /Android/i.test(navigator.userAgent),
    iOS: (): boolean => /iPhone|iPad|iPod/i.test(navigator.userAgent),
    any: (): boolean => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent),
  };

  const page = document.querySelector<HTMLElement>('#page');
  if (!page) return;

  const disableElements = (selector: string): void => {
    document.querySelectorAll<HTMLElement>(selector).forEach(el => {
      el.classList.add('disabled');
    });
  };

  // Apply device classes
  if (!isMobile.any()) {
    disableElements('.show-ios');
    disableElements('.show-android');
  }

  if (isMobile.iOS()) {
    page.classList.add('device-is-ios');
    disableElements('.show-android');
    disableElements('.show-no-device');
  }

  if (isMobile.Android()) {
    page.classList.add('device-is-android');
    disableElements('.show-ios');
    disableElements('.show-no-device');
  }

  // iOS version check
  const match = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
  if (match && parseInt(match[1], 10) > 14) {
    page.classList.add('min-ios15');
  }
}
